import { Container } from "react-bootstrap";

export default function Terms() {
  return (
    <main className="py-5">
      <Container style={{ maxWidth: 900 }}>
        <h1 className="mb-4">Terms & Conditions</h1>

        <p>
          These Terms and Conditions govern the use of the website
          <strong> lylescoaching.com</strong> and the services offered by
          Lyle’s Coaching.
        </p>

        <h3 className="mt-4">1. Services</h3>
        <p>
          Lyle’s Coaching provides online fitness coaching, training programs,
          and digital content. All services are delivered digitally unless
          explicitly stated otherwise.
        </p>

        <h3 className="mt-4">2. Digital Products</h3>
        <p>
          Training programs and digital products are delivered electronically.
          Once purchased, digital products are non-refundable unless required
          by applicable law.
        </p>

        <h3 className="mt-4">3. User Responsibilities</h3>
        <p>
          You agree to provide accurate information and to use the services in
          a lawful manner. Any misuse of the platform may result in suspension
          or termination of access.
        </p>

        <h3 className="mt-4">4. Health Disclaimer</h3>
        <p>
          The content provided is for informational purposes only and does not
          constitute medical advice. Always consult a qualified healthcare
          professional before starting any fitness program.
        </p>

        <h3 className="mt-4">5. Limitation of Liability</h3>
        <p>
          Lyle’s Coaching shall not be held liable for any direct or indirect
          damages arising from the use of the services, to the maximum extent
          permitted by law.
        </p>

        <h3 className="mt-4">6. Payments</h3>
        <p>
          Payments are processed securely via third-party providers (e.g.
          Stripe). Lyle’s Coaching does not store payment card details.
        </p>

        <h3 className="mt-4">7. Changes to Terms</h3>
        <p>
          These Terms may be updated at any time. Continued use of the website
          constitutes acceptance of the updated Terms.
        </p>

        <h3 className="mt-4">8. Contact</h3>
        <p>
          For any questions regarding these Terms, please contact:
          <br />
          <strong>Email:</strong> info@lylescoaching.com
        </p>

        <p className="mt-5 text-muted">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </Container>
    </main>
  );
}
